import Countdown from './modules/timer';
import RTE from "./modules/rte";
import BISToggle from './modules/bis-toggle';
import ProductCalculators from './modules/calculators';

new Countdown();
new RTE();
new BISToggle();
new ProductCalculators();
